import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { IconPointerDown } from '@alfa-bank/site-icon/pointer-down';
import { DataLayer } from '@alfa-bank/site-data-layer';
import { ArrowPopover as Tooltip } from '@alfa-bank/site-popover/arrow-popover';

import styles from '../../styles/styles.css';
import { BannerLink } from '../banner-link';

import { InternetBank as Component } from './internet-bank';
import type { IDeps, TInternetBank } from './models';

export const InternetBank = createWidget<IDeps, TInternetBank>({
    BannerLink,
    DataLayer,
    IconPointerDown,
    Tooltip,
    styles,
})(Component);
